import React, { useState } from "react";
import { useGetList } from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { scholarshipRequests } from "api/scholarshipApi";
import AddScholarshipBudgetDialog from "./AddScholarshipBudgetDialog";
import UpdateScholarshipBudgetDialog from "./UpdateScholarshipBudgetDialog";

const ScholarshipBudgetMobileExpanded = ({ record }) => {
  const [expanded, setExpanded] = useState(false);
  const { data } = useGetList(
    scholarshipRequests.getScholarshipBudgetByYear(record?.fiscalYear),
    {},
    { enabled: expanded },
  );

  return (
    <Accordion
      sx={{ width: "100%" }}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
        <Typography sx={{ fontWeight: "bold" }}>Детайли</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ width: "100%" }}>
        {data?.map((item, idx) => {
          return (
            <div
              key={item.structuralUnitId ?? idx}
              style={settings.style.shadowBoxMobile}
            >
              <MobileListRow
                fields={[
                  {
                    label: "Факултет",
                    value: item.structuralUnitName,
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Сума",
                    value: item.amount,
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Изразходвана сума",
                    value: item.spentAmount,
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Неразпределен бюджет",
                    value: item.unallocatedAmount,
                  },
                ]}
              />
              {item.hasBudget ? (
                <SecuredComponent permission={permissions.canUpdateScholarshipBudgets}>
                  <UpdateScholarshipBudgetDialog
                    budgetId={item?.budgetId}
                    structuralUnitName={item?.structuralUnitName}
                  />
                </SecuredComponent>
              ) : (
                <SecuredComponent permission={permissions.canCreateScholarshiBudgets}>
                  <AddScholarshipBudgetDialog
                    fiscalYear={record.fiscalYear}
                    structuralUnitId={item?.structuralUnitId}
                    structuralUnitName={item?.structuralUnitName}
                  />
                </SecuredComponent>
              )}
            </div>
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
};

export default ScholarshipBudgetMobileExpanded;
